/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  GetWarehouseVendorsParams,
  HTTPValidationError,
  WarehouseVendor,
  WarehouseVendorBase,
  WarehouseVendorCreate,
  WarehouseVendorWithVendor,
} from "./fastAPI.schemas";

import { customInstance } from "../../axios";
import type { ErrorType } from "../../axios";

/**
 * Route to create a new warehouse_vendor.
 * @summary Create Warehouse Vendor
 */
export const createWarehouseVendor = (
  warehouseVendorCreate: WarehouseVendorCreate,
  signal?: AbortSignal,
) => {
  return customInstance<WarehouseVendorBase>({
    url: `/api/warehouse_vendor/`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: warehouseVendorCreate,
    signal,
  });
};

export const getCreateWarehouseVendorMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWarehouseVendor>>,
    TError,
    { data: WarehouseVendorCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createWarehouseVendor>>,
  TError,
  { data: WarehouseVendorCreate },
  TContext
> => {
  const mutationKey = ["createWarehouseVendor"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createWarehouseVendor>>,
    { data: WarehouseVendorCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createWarehouseVendor(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateWarehouseVendorMutationResult = NonNullable<
  Awaited<ReturnType<typeof createWarehouseVendor>>
>;
export type CreateWarehouseVendorMutationBody = WarehouseVendorCreate;
export type CreateWarehouseVendorMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Create Warehouse Vendor
 */
export const useCreateWarehouseVendor = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createWarehouseVendor>>,
      TError,
      { data: WarehouseVendorCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createWarehouseVendor>>,
  TError,
  { data: WarehouseVendorCreate },
  TContext
> => {
  const mutationOptions = getCreateWarehouseVendorMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to get many warehouse_vendors for a specific warehouse.
 * @summary Get Warehouse Vendors
 */
export const getWarehouseVendors = (
  params: GetWarehouseVendorsParams,
  signal?: AbortSignal,
) => {
  return customInstance<WarehouseVendorWithVendor[]>({
    url: `/api/warehouse_vendor/`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetWarehouseVendorsQueryKey = (
  params?: GetWarehouseVendorsParams,
) => {
  return ["api", "warehouse_vendor", ...(params ? [params] : [])] as const;
};

export const getGetWarehouseVendorsQueryOptions = <
  TData = Awaited<ReturnType<typeof getWarehouseVendors>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: GetWarehouseVendorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWarehouseVendors>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetWarehouseVendorsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWarehouseVendors>>
  > = ({ signal }) => getWarehouseVendors(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWarehouseVendors>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetWarehouseVendorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWarehouseVendors>>
>;
export type GetWarehouseVendorsQueryError =
  ErrorType<void | HTTPValidationError>;

export function useGetWarehouseVendors<
  TData = Awaited<ReturnType<typeof getWarehouseVendors>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: GetWarehouseVendorsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWarehouseVendors>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWarehouseVendors>>,
          TError,
          Awaited<ReturnType<typeof getWarehouseVendors>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetWarehouseVendors<
  TData = Awaited<ReturnType<typeof getWarehouseVendors>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: GetWarehouseVendorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWarehouseVendors>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWarehouseVendors>>,
          TError,
          Awaited<ReturnType<typeof getWarehouseVendors>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetWarehouseVendors<
  TData = Awaited<ReturnType<typeof getWarehouseVendors>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: GetWarehouseVendorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWarehouseVendors>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Warehouse Vendors
 */

export function useGetWarehouseVendors<
  TData = Awaited<ReturnType<typeof getWarehouseVendors>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: GetWarehouseVendorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWarehouseVendors>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetWarehouseVendorsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to get an warehouse by ID.
 * @summary Get Warehouse Vendor
 */
export const getWarehouseVendor = (
  warehouseVendorId: number,
  signal?: AbortSignal,
) => {
  return customInstance<WarehouseVendor>({
    url: `/api/warehouse_vendor/${warehouseVendorId}`,
    method: "GET",
    signal,
  });
};

export const getGetWarehouseVendorQueryKey = (warehouseVendorId?: number) => {
  return ["api", "warehouse_vendor", warehouseVendorId] as const;
};

export const getGetWarehouseVendorQueryOptions = <
  TData = Awaited<ReturnType<typeof getWarehouseVendor>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  warehouseVendorId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWarehouseVendor>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetWarehouseVendorQueryKey(warehouseVendorId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWarehouseVendor>>
  > = ({ signal }) => getWarehouseVendor(warehouseVendorId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!warehouseVendorId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getWarehouseVendor>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetWarehouseVendorQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWarehouseVendor>>
>;
export type GetWarehouseVendorQueryError =
  ErrorType<void | HTTPValidationError>;

export function useGetWarehouseVendor<
  TData = Awaited<ReturnType<typeof getWarehouseVendor>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  warehouseVendorId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWarehouseVendor>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWarehouseVendor>>,
          TError,
          Awaited<ReturnType<typeof getWarehouseVendor>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetWarehouseVendor<
  TData = Awaited<ReturnType<typeof getWarehouseVendor>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  warehouseVendorId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWarehouseVendor>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWarehouseVendor>>,
          TError,
          Awaited<ReturnType<typeof getWarehouseVendor>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetWarehouseVendor<
  TData = Awaited<ReturnType<typeof getWarehouseVendor>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  warehouseVendorId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWarehouseVendor>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Warehouse Vendor
 */

export function useGetWarehouseVendor<
  TData = Awaited<ReturnType<typeof getWarehouseVendor>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  warehouseVendorId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWarehouseVendor>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetWarehouseVendorQueryOptions(
    warehouseVendorId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to update an warehouse_vendor by ID.
 * @summary Update Warehouse Vendor
 */
export const updateWarehouseVendor = (
  warehouseVendorId: number,
  warehouseVendorCreate: WarehouseVendorCreate,
) => {
  return customInstance<unknown>({
    url: `/api/warehouse_vendor/${warehouseVendorId}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: warehouseVendorCreate,
  });
};

export const getUpdateWarehouseVendorMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWarehouseVendor>>,
    TError,
    { warehouseVendorId: number; data: WarehouseVendorCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateWarehouseVendor>>,
  TError,
  { warehouseVendorId: number; data: WarehouseVendorCreate },
  TContext
> => {
  const mutationKey = ["updateWarehouseVendor"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateWarehouseVendor>>,
    { warehouseVendorId: number; data: WarehouseVendorCreate }
  > = (props) => {
    const { warehouseVendorId, data } = props ?? {};

    return updateWarehouseVendor(warehouseVendorId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateWarehouseVendorMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateWarehouseVendor>>
>;
export type UpdateWarehouseVendorMutationBody = WarehouseVendorCreate;
export type UpdateWarehouseVendorMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Warehouse Vendor
 */
export const useUpdateWarehouseVendor = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateWarehouseVendor>>,
      TError,
      { warehouseVendorId: number; data: WarehouseVendorCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateWarehouseVendor>>,
  TError,
  { warehouseVendorId: number; data: WarehouseVendorCreate },
  TContext
> => {
  const mutationOptions = getUpdateWarehouseVendorMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
